// FlowBerry Rose Variety Catalog
// Owner photos should be placed in /public/assets/varieties/

export const roseCatalog = [
  {
    id: 1,
    name: 'Country Blue',
    slug: 'country-blue',
    photoPath: '/assets/varieties/country-blue.jpg',
    note: 'Elegant lavender-blue tones',
    priceMultiplier: 1.0,
    extraPer25: 0,
  },
  {
    id: 2,
    name: 'Explorer',
    slug: 'explorer',
    photoPath: '/assets/varieties/explorer.jpg',
    note: 'Rich and adventurous',
    priceMultiplier: 1.0,
    extraPer25: 0,
  },
  {
    id: 3,
    name: 'Frutteto',
    slug: 'frutteto',
    photoPath: '/assets/varieties/frutteto.jpg',
    note: 'Soft peachy elegance',
    priceMultiplier: 1.0,
    extraPer25: 0,
  },
  {
    id: 4,
    name: 'Gotcha',
    slug: 'gotcha',
    photoPath: '/assets/varieties/gotcha.jpg',
    note: 'Stunning coral beauty',
    priceMultiplier: 1.0,
    extraPer25: 0,
  },
  {
    id: 5,
    name: 'Kahala',
    slug: 'kahala',
    photoPath: '/assets/varieties/kahala.jpg',
    note: 'Romantic blush pink',
    priceMultiplier: 1.0,
    extraPer25: 0,
  },
  {
    id: 6,
    name: 'Mandala',
    slug: 'mandala',
    photoPath: '/assets/varieties/mandala.jpg',
    note: 'Warm sunset hues',
    priceMultiplier: 1.0,
    extraPer25: 0,
  },
  {
    id: 7,
    name: 'Mondial',
    slug: 'mondial',
    photoPath: '/assets/varieties/mondial.jpg',
    note: 'Classic pure white',
    priceMultiplier: 1.0,
    extraPer25: 0,
  },
  {
    id: 8,
    name: 'Orange Crush',
    slug: 'orange-crush',
    photoPath: '/assets/varieties/orange-crush.jpg',
    note: 'Vibrant citrus orange',
    priceMultiplier: 1.0,
    extraPer25: 0,
  },
  {
    id: 9,
    name: 'Lighthouse',
    slug: 'lighthouse',
    photoPath: '/assets/varieties/lighthouse.jpg',
    note: 'Brilliant golden yellow',
    priceMultiplier: 1.0,
    extraPer25: 0,
  },
  {
    id: 10,
    name: 'Deep Purple',
    slug: 'deep-purple',
    photoPath: '/assets/varieties/deep-purple.jpg',
    note: 'Mysterious deep violet',
    priceMultiplier: 1.0,
    extraPer25: 0,
  },
];

export const getRoseById = (id) => roseCatalog.find((rose) => rose.id === id);
export const getRoseBySlug = (slug) => roseCatalog.find((rose) => rose.slug === slug);

export default roseCatalog;
